// src/pages/admin/tabs/parts/ManagersPanel.jsx

import React from 'react';
import { AdminAPI } from '../../../../api/admin';
import { Card, Row2, Field, Actions, Btn, Badge, TableWrap, Table } from '../../ui';

export default function ManagersPanel({ propertyId, propertyType = 'regular' }) {
  const [links, setLinks] = React.useState([]);
  const [managers, setManagers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState('');
  const [ok, setOk] = React.useState('');
  const [pickId, setPickId] = React.useState('');
  const [sort, setSort] = React.useState(0);
  const [isPrimary, setPrimary] = React.useState(false);

  // Определяем API методы в зависимости от типа объекта
  const getApiMethods = () => {
    switch (propertyType) {
      case 'foreign':
        return {
          list: AdminAPI.listForeignPropertyManagers,
          attach: AdminAPI.attachForeignPropertyManager,
          update: AdminAPI.updateForeignPropertyManager,
          delete: AdminAPI.deleteForeignPropertyManager,
        };
      case 'suburban':
        return {
          list: AdminAPI.listSuburbanPropertyManagers,
          attach: AdminAPI.attachSuburbanPropertyManager,
          update: AdminAPI.updateSuburbanPropertyManager,
          delete: AdminAPI.deleteSuburbanPropertyManager,
        };
      case 'commercial-rent':
        return {
          list: AdminAPI.listCommercialRentPropertyManagers,
          attach: AdminAPI.attachCommercialRentPropertyManager,
          update: AdminAPI.updateCommercialRentPropertyManager,
          delete: AdminAPI.deleteCommercialRentPropertyManager,
        };
      case 'parking':
        return {
          list: AdminAPI.listParkingPropertyManagers,
          attach: AdminAPI.attachParkingPropertyManager,
          update: AdminAPI.updateParkingPropertyManager,
          delete: AdminAPI.deleteParkingPropertyManager,
        };
      default:
        return {
          list: AdminAPI.listPropertyManagers,
          attach: AdminAPI.attachPropertyManager,
          update: AdminAPI.updatePropertyManager,
          delete: AdminAPI.deletePropertyManager,
        };
    }
  };

  const api = React.useMemo(() => getApiMethods(), [propertyType]);

  const load = React.useCallback(async ()=>{
    setLoading(true); setErr(''); setOk('');
    try{
      const [ls, ms] = await Promise.all([
        api.list(propertyId),
        AdminAPI.listManagers({ is_active: 'true', page_size: 200 }).catch(()=>({ items: [] })),
      ]);
      setLinks(ls?.items || ls || []);
      setManagers(ms?.items || []);
    }catch(e){ setErr(e?.message || 'Не удалось загрузить менеджеров'); }
    finally{ setLoading(false); }
  }, [propertyId, api]);
  React.useEffect(()=>{ if(propertyId) load(); }, [propertyId, load]);

  const attach = async ()=>{
    if(!pickId) return;
    try{
      await api.attach(propertyId, { manager_id: Number(pickId), sort_order: Number(sort)||0, is_primary: !!isPrimary });
      setOk('Менеджер привязан');
      setPickId(''); setSort(0); setPrimary(false);
      await load();
    }catch(e){ setErr(e?.message || 'Не удалось привязать'); }
  };

  const patch = async (link, patch)=>{
    try{ await api.update(propertyId, link.id, patch); await load(); }
    catch(e){ alert(e?.message || 'Не удалось сохранить'); }
  };
  const del = async (link)=>{
    if(!window.confirm('Убрать менеджера из объекта?')) return;
    try{ await api.delete(propertyId, link.id); await load(); }
    catch(e){ alert(e?.message || 'Не удалось удалить'); }
  };

  const fmtName = (m)=> `${m.first_name ?? m.first_name_ru ?? ''} ${m.last_name ?? m.last_name_ru ?? ''}`.trim() || m.phone || m.email || `#${m.id}`;

  return (
    <Card>
      <h3>Менеджеры объекта {loading ? '(загрузка...)' : ''}</h3>
      {err && <div style={{color:'#e66'}}>{err}</div>}
      {ok && <div style={{color:'#2a8f2a'}}>{ok}</div>}

      <Row2>
        <Field>Менеджер
          <select value={pickId} onChange={e=>setPickId(e.target.value)}>
            <option value="">— выбрать —</option>
            {managers.map(m=> <option key={m.id} value={m.id}>{fmtName(m)} (#{m.id})</option>)}
          </select>
        </Field>
        <Field>Сортировка<input type="number" value={sort} onChange={e=>setSort(e.target.value)} /></Field>
        <Field>Основной
          <select value={isPrimary ? '1':'0'} onChange={e=>setPrimary(e.target.value==='1')}>
            <option value="0">Нет</option><option value="1">Да</option>
          </select>
        </Field>
      </Row2>
      <Actions style={{marginTop:8}}>
        <Btn $kind="primary" onClick={attach} disabled={!pickId}>+ Привязать</Btn>
      </Actions>

      <TableWrap style={{marginTop:12}}>
        <Table>
          <thead>
            <tr>
              <th>ID</th><th>Имя</th><th>Основной</th><th>Сортировка</th><th></th>
            </tr>
          </thead>
          <tbody>
            {links.map(l=>(
              <tr key={l.id}>
                <td>{l.id}</td>
                <td>{fmtName(l.manager || {})}</td>
                <td>
                  <select value={l.is_primary ? '1':'0'} onChange={(e)=>patch(l, { is_primary: e.target.value==='1' })}>
                    <option value="1">Да</option><option value="0">Нет</option>
                  </select>
                </td>
                <td>
                  <input type="number" value={l.sort_order ?? 0} onChange={(e)=>patch(l, { sort_order: Number(e.target.value)||0 })} style={{width:90}}/>
                </td>
                <td><Btn onClick={()=>del(l)}>Удалить</Btn></td>
              </tr>
            ))}
            {!links.length && <tr><td colSpan={5} style={{opacity:.7}}>Ни одного менеджера не привязано</td></tr>}
          </tbody>
        </Table>
      </TableWrap>
    </Card>
  );
}
